<template>
  <div>
    <div class="container cid-detail">
      <div class="container-img" v-if="product.get('productCode') == 'CID'">
        <loading-grid class="loading-grid-img" v-show="isLoadImage" />
        <img :src="imageUrl" alt="Baner" @load="loaded()" />
      </div>

      <div class="row">
        <div class="col-md-6">
          <images-carousel v-if="product.get('images').length > 0" :Images="product.get('images')" />
        </div>
        <div class="col-md-6 container-detail">
          <div class="product-name">{{product.get('name')}}</div>
          <p class="viewer-count">จำนวนการดู {{product.get('viewerCounter') || 0}} ครั้ง</p>
          <p
            class="viewer-count"
            v-if="balanceStore"
            v-show="!isLoadBalanceStore"
          >จำนวนคงเหลือ {{!product.get('isSoldOut') ? balanceStore.balanceProduct || 0 : 0}} {{ product.get('productCode') == 'CID' ? 'เครื่อง' : product.get('unitType')}}</p>
          <loading-worm class="viewer-count" v-if="isLoadBalanceStore" size="small" />

          <br />

          <p class="price mb-0" v-if="product.get('price')" style="font-size:28px">
            <small
              v-if="product.get('fullPrice') && !product.get('subProducts')"
              class="text-muted" style="font-size:16px;text-decoration: line-through;"
            >฿{{eArabic(product.get('fullPrice') , 2)}}</small>
            <small
              v-if="selectSubProduct && selectSubProduct.get('fullPrice')"
              class="text-muted" style="font-size:16px;text-decoration: line-through;"
            >฿{{eArabic(selectSubProduct.get('fullPrice') , 2)}}</small>
            <br />
            <span v-if="product.get('subProducts')">
              <span
                v-if="!selectSubProductId"
              >ราคา {{ eArabic(Math.min(...product.get('subProducts').map(d => d.get('price')))) }} - {{ eArabic(Math.max(...product.get('subProducts').map(d => d.get('price')))) }} บาท</span>
              <span v-else-if="selectSubProduct">ราคา {{eArabic(selectSubProduct.get('price'))}} บาท</span>
            </span>
            <span v-else>ราคา {{eArabic(product.get('price'))}} บาท</span>
            <small class="text-muted" style="font-size:16px">/{{product.get('productCode') == 'CID' ? 'เครื่อง' : product.get('unitType')}}</small>
          </p>
          <!-- <p v-if="selectSubProduct">
          ค่าส่ง {{eArabic(selectSubProduct.get('deliveryPerNumber'))}}
          </p>-->
          <!-- <small v-if="product.get('delivery') && product.get('delivery') > 0" style="padding-left:10px;">ค่าจัดส่ง {{product.get('delivery')}} บาท</small>
          <small v-else-if="product.get('price') && (!product.get('delivery') || product.get('delivery') == 0)" style="padding-left:10px;">ค่าจัดส่งฟรี <img src="../assets/icon/sendfree.png" alt="promo" width="30px" /> </small>-->

          <div class="box-detail" v-if="product.get('detail')">
            <!-- <h4>คุณสมบัติสินค้า</h4> -->
            <div class="html-detail" v-html="product.get('detail')"></div>
          </div>
          <!-- <div class="box-detail" v-if="product.get('description')">
          <h4>ข้อมูลสินค้า</h4>
          
          </div>-->

          <div class="box-number mt-4 border-top">
            <div class="row">
              <div class="col-md-12 py-2 text-left" v-if="product.get('subProducts')">
                ตัวเลือก :
                <template v-for="subProduct in product.get('subProducts')">
                  <div
                    :class="`select-sub-product ${selectSubProductId == subProduct.id ? 'active' : '' }`"
                    :key="subProduct.id"
                    @click="changeSubProduct(subProduct)"
                  >{{ subProduct.get('subProductName')}}</div>
                </template>
              </div>
              <div class="col-md-12 py-2">
                ระบุจำนวนสินค้า :
                <i
                  :class="`fas fa-minus ${formPurchase.number < 2 ? 'none':''}`"
                  @click="numberPluse('-')"
                ></i>
                <input
                  type="number"
                  name="number-order"
                  id="number-order"
                  v-model.number="formPurchase.number"
                  placeholder="จำนวน"
                  min="1"
                  max="9"
                  @keypress="isNumberPurchase()"
                  @input="changeNumber()"
                />
                <i
                  :class="`fas fa-plus ${balanceStore && formPurchase.number >= balanceStore.balanceProduct ? 'none':''}`"
                  @click="numberPluse('+')"
                ></i>
              </div>
              <div class="col-md-12" v-if="isErrorSelectSubProduct">
                <span class="text-danger">
                  <small>กรุณาเลือกตัวเลือกของสินค้าก่อน</small>
                </span>
              </div>
            </div>
          </div>
          <div class="box-btn-quotation" v-show="!isLoadInit">
            <div class="row">
              <div class="col-md-8 px-4 row">
                <div class="col-md-7 px-1">
                  <button
                    type="button"
                    :class="`btn btn-outline-primary w-100 w100-mobile ${product.get('isSoldOut') || isLoadBalanceStore || (balanceStore && balanceStore.balanceProduct <= 0) ? 'non-active':''}`"
                    @click="addToCart()"
                  >
                    <i class="fas fa-shopping-basket"></i> เพิ่มไปยังตะกร้า
                  </button>
                </div>
                <div class="col-md-5 px-1">
                  <button
                    type="button"
                    :class="`btn btn-primary w-100 w100-mobile ${product.get('isSoldOut') || isLoadBalanceStore || (balanceStore && balanceStore.balanceProduct <= 0) ? 'non-active':''}`"
                    @click="requestQuotation()"
                  >ซื้อสินค้า</button>
                </div>
              </div>
            </div>
            <hr />
            <router-link
              v-if="false && product.get('productCode') == 'CID'"
              to="/register-cid"
              class="btn btn-outline-secondary"
            >เปิดใช้งานเครื่องอ่านบัตร</router-link>
            <div
              class="text-last-purchase"
              v-if="lastPurchase && lastPurchase.get('orders') && lastPurchase.get('orders')[0].productId == product.id"
            >{{`ซื้อครั้งล่าสุด(${dateFormat(lastPurchase.get('purchaseDate'),'DD/MM/YY')}) ${lastPurchase.get('orders')[0].number} ชิ้น`}}</div>
          </div>
          <!-- <div class="box-btn-quotation" v-show="isLoadInit">
            <loading-cycle />
          </div> -->
        </div>
      </div>

      <div class="mt-3" v-if="product.get('description')">
        <div class="col-12 border-bottom">
          <h3><b>ข้อมูลสินค้า</b></h3>
        </div>
        <div class="col-12">
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div class="ql-snow">
                <div class="ql-editor">
                  <div v-html="product.get('description')"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <product-carousel :currentProduct="product.id"></product-carousel>
      
    </div>
  </div>
</template>

<script>
import store from "../store";
import { mapState } from "vuex";
export default {
  props: ["product"],
  data() {
    return {
      isLoadImage: true,
      isLoadInit: false,
      interested: false,
      formPurchase: { number: 1 },
      isLoadBalanceStore: false,
      balanceStore: null,
      lastPurchase: null,
      selectSubProductId: null,
      selectSubProduct: null,
      isErrorSelectSubProduct: false
    };
  },
  async mounted() {
    this.getBalanceStore();
  },
  methods: {
    loaded() {
      if (true) {
        this.isLoadImage = false;
        this.$mount();
      }
    },
    async requestQuotation() {
      if (
        this.product &&
        this.product.get("subProducts") &&
        !this.selectSubProductId
      ) {
        this.isErrorSelectSubProduct = true;
      } else {
        this.isErrorSelectSubProduct = false;
        let product;

        if (this.product.get("subProducts")) {
          product = this.product
            .get("subProducts")
            .find(d => d.id == this.selectSubProductId);
        } else {
          product = this.product;
        }

        this.purchaseProduct = {
          id: product.id,
          name: product.get("name"),
          image: product.get("images") ? this.$imgUrl(product.get("images")[0]) : "",
          number: this.formPurchase.number,
          fullPrice: product.get("fullPrice"),
          price: product.get("price"),
          isIncludeVat: product.get("isIncludeVat"),
          balanceProduct: this.balanceStore.balanceProduct,
          delivery: product.get("delivery") || 0,
          deliveryPerNumber: product.get("deliveryPerNumber") || 0,
          deliveryCategory: product.get("deliveryCategory"),
          productList: product.get("productList") || [],
          discount: product.get("discount") || {}
        };

        store.commit("setFromBuyNow", true);
        $("#main-cid-detail").addClass("modal-open");
        $("#modal-purchase").removeClass("modal-purchase-hide");
        $("body").css({ "overflow-y": "hidden" });

        $("#cart-bar").addClass("hide-cart");
        $("#cart-bar").removeClass("show-cart");

        store.commit("setPurchasingProduct", [this.purchaseProduct]);
        localStorage.setItem(
          "purchase",
          JSON.stringify([this.purchaseProduct])
        );

        if (!this.interested)
          await this.Parse.Cloud.run("MarketProduct_counterInterest", {
            productId: this.$route.params.productId
          }).catch(err => {
              console.log(err);
            });
          this.interested = true;
      }
    },
    async addToCart() {
      if (
        this.product &&
        this.product.get("subProducts") &&
        !this.selectSubProductId
      ) {
        this.isErrorSelectSubProduct = true;
      } else {
        this.isErrorSelectSubProduct = false;
        let objCart = {
          productId:
            this.product.get("subProducts") && this.selectSubProductId
              ? this.selectSubProductId
              : this.product.id,
          number: this.formPurchase.number
        };

        if (localStorage.getItem("carts")) {
          if (
            JSON.parse(localStorage.getItem("carts")).findIndex(
              item => item.productId === this.product.id
            ) <= -1
          ) {
            let carts = JSON.parse(localStorage.getItem("carts"));
            let balanceStore = await this.Parse.Cloud.run(
              "MarketProduct_countBalanceStore",
              { productId: this.product.id }
            );

            carts.push(objCart);

            localStorage.setItem("carts", JSON.stringify(carts));
            store.commit("setCarts", carts);
            store.commit("addHashBalanceProduct", balanceStore);
          } else {
            let carts = JSON.parse(localStorage.getItem("carts"));
            for (let cart of carts) {
              if (cart.productId == this.product.id) {
                cart.number = this.formPurchase.number;
              }
            }
            localStorage.setItem("carts", JSON.stringify(carts));
            store.commit("setCarts", carts);
          }
        } else {
          localStorage.setItem("carts", JSON.stringify([objCart]));
          store.commit("setCarts", [objCart]);
        }

        // $("#myToast").toast({ delay: 3000 });
        $("#addCartToast").addClass("show");
        $("#addCartToast").removeClass("hide");

        setTimeout(function() {
          $("#addCartToast").removeClass("show");
          $("#addCartToast").addClass("hide");
        }, 2000);

        this.formPurchase.number = 1;
      }
    },
    isNumberPurchase: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      let key = evt.key;
      let sum = new Number(this.formPurchase.number.toString() + key);
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57 || charCode == 190)
        // && charCode !== 46 //dot
        // && charCode !== 32 //space bar
      ) {
        evt.preventDefault();
      } else {
        if (
          sum > -1 &&
          sum < 10 &&
          this.balanceStore &&
          sum <= this.balanceStore.balanceProduct
        ) {
          return true;
        } else {
          evt.preventDefault();
        }
      }
    },
    numberPluse(data) {
      if (data == "+") {
        let number = new Number(this.formPurchase.number) + 1;
        if (
          number > -1 &&
          this.balanceStore &&
          number <= this.balanceStore.balanceProduct
        ) {
          this.formPurchase.number = number;
        }
      } else if (data == "-") {
        let number = new Number(this.formPurchase.number) - 1;
        if (
          number > 0 &&
          this.balanceStore &&
          number <= this.balanceStore.balanceProduct
        ) {
          this.formPurchase.number = number;
        }
      }
    },
    dateFormat(date, fmt) {
      return date ? this.$moment(date).format(fmt) : "";
    },
    async getBalanceStore(_product) {
      try {
        let product = _product || this.product;
        this.isLoadBalanceStore = true;

        if (!this.hashBalanceProduct[product.id]) {
          this.balanceStore = await this.Parse.Cloud.run(
            "MarketProduct_countBalanceStore",
            { productId: product.id }
          );
          store.commit("addHashBalanceProduct", this.balanceStore);
        } else {
          this.balanceStore = this.hashBalanceProduct[product.id];
        }

        this.isLoadBalanceStore = false;
      } catch (error) {
        console.log(error);
      }
    },
    eArabic(x, num = 0) {
      if (x)
        return x.toLocaleString(undefined, {
          minimumFractionDigits: num,
          maximumFractionDigits: num
        });
      else return num == 2 ? "0.00" : "0";
    },
    changeSubProduct(subProduct) {
      this.selectSubProductId = subProduct.id;
      this.selectSubProduct = this.product
        .get("subProducts")
        .find(d => d.id == this.selectSubProductId);
      this.isErrorSelectSubProduct = false;
      this.formPurchase.number = 1;
      this.getBalanceStore(subProduct);
    }
  },
  computed: {
    imageUrl() {
      if (this.product.get("productCode") == "CID") {
        if (this.product.id == "rWco618dfj") {
          return require("../assets/images/banner/card-reader-gen2.jpg");
        } else {
          return require("../assets/images/banner/card-reader-bn2.jpg");
        }
      } else if (this.product.get("productCode") == "FRT") {
        return require("../assets/images/banner/frt.png");
      } else {
        return "";
      }
    },
    ...mapState(["user", "apartment", "hashBalanceProduct", "owners"])
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #fff;
  padding: 5px 20px 40px;
  max-width: 1300px;
}
img {
  width: 100%;
  height: auto;
}
.price {
  color: var(--primary);
  font-weight: bold;
  padding-left: 10px;
  margin-top: 10px;
}
.tab-content {
  padding: 20px 10px 20px 30px;
  min-height: 200px;
}
.select-sub-product {
  border: 1px solid rgb(172, 172, 172);
  padding: 5px 15px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
  &.active {
    border: 3px solid var(--primary);
  }
}
@media (max-width: 768px) {
  .tab-content {
    padding: 5px 0 5px 10px;
  }
  .w100-mobile {
    width: 100% !important;
  }
}
</style>
